package com.example.hukakmp.identification

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.app
import dev.gitlive.firebase.js

private const val AI_FIREBASE_APP_NAME = "huka-ai-web"

private var cachedAiApp: dynamic = null

fun firebaseAiApp(): dynamic {
    val cached = cachedAiApp
    if (cached != null) return cached

    val apps = getApps()
    for (index in apps.indices) {
        val candidate = apps[index]
        if (candidate.name?.toString() == AI_FIREBASE_APP_NAME) {
            cachedAiApp = candidate
            return candidate
        }
    }

    // Reutilizamos solo el objeto plano de configuración del Firebase ya
    // inicializado por GitLive. La instancia AI pertenece al SDK JS nuevo.
    val options = Firebase.app.js.options
    val initializedApp = initializeApp(options, AI_FIREBASE_APP_NAME)
    cachedAiApp = initializedApp
    return initializedApp
}
